import api from './axios';

const BASE = '/raw-materials';

export const getRawMaterials = (page = 0, size = 20) =>
  api.get(BASE, { params: { page, size } });

export const createRawMaterial = (data) => api.post(BASE, data);

export const updateRawMaterial = (id, data) => api.put(`${BASE}/${id}`, data);

export const deleteRawMaterial = (id) => api.delete(`${BASE}/${id}`);

export const getRawMaterialPurchases = (id, page = 0, size = 50) =>
  api.get(`${BASE}/${id}/purchases`, { params: { page, size } });

export const createRawMaterialPurchase = (id, data) =>
  api.post(`${BASE}/${id}/purchases`, data);

export const deleteRawMaterialPurchase = (id, purchaseId) =>
  api.delete(`${BASE}/${id}/purchases/${purchaseId}`);

export const getProductBom = (productId) =>
  api.get(`/products/${productId}/bom`);

export const replaceProductBom = (productId, items) =>
  api.put(`/products/${productId}/bom`, { items });
